// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function BothEmptyValidator(
  startKey: string,
  endKey: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const start = control.get(startKey)?.value;
    const end = control.get(endKey)?.value;

    const isEmpty = (v: any) =>
      v === null || v === undefined || v === '';

    if (isEmpty(start) && isEmpty(end)) {
      return { bothEmpty: true };
    }

    return null;
  };
}
